<script setup>
import { Head, usePage } from '@inertiajs/vue3';
import Button from 'primevue/button';
import Message from 'primevue/message';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';

const page = usePage();

const user = page.props.user;
const key = page.props.key;
const order = page.props.order;
const timeSlot = page.props.pickup_time_slot;

const currencyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

const isPickupSlipAvailable = [ 'processing', 'completed' ].includes(order.status);

const referenceTableRows = [
  [ 'E-mail', order.email ],
  [ 'Nom', order.lastname ],
  [ 'Prénom', order.firstname ],
  [ 'Téléphone', order.phone ],
  [ 'Adresse', order.address ],
  [ 'Code postal', order.postcode ],
  [ 'Ville', order.city ],
  [ 'Date de naissance', order.dob ],
  [ 'Quantité chèques', order.quantity ],
  [ 'Valeur totale chèques', currencyFormatter.format(order.regular_unit_price * order.quantity) ],
  [ 'Prix payé', currencyFormatter.format(order.total_amount) ],
  [ 'Créneau de retrait', `${timeSlot.date} entre ${timeSlot.hour}h et ${timeSlot.hour + 1}h` ],
  [ 'Adresse de retrait', `Conciergerie Mon Shopping C\'est Calais\n6 Boulevard Jacquard\n62100 - Calais` ]
];

const printSlip = (event) => {
  event.preventDefault();
  event.stopPropagation();
  window.print();
};
</script>

<template>
  <Head title="Bon de retrait"/>

  <div class="min-h-full">
    <header class="py-8 flex justify-center">
      <a :href="route('order.form')">
        <ApplicationLogo class="w-72"/>
      </a>
    </header>

    <main
        class="relative max-w-3xl px-4 py-4 sm:px-6 lg:px-8 flex flex-col justify-center sm:items-center mx-auto size-full">
      <div class="text-center pb-4 px-4 sm:px-6 lg:px-8 size-full">
        <h1 class="text-xl sm:text-2xl text-primary uppercase font-semibold text-slate-500">
          Commande n° <span class="text-primary">{{ order.reference }}</span> -
          <nobr>Bon de retrait</nobr>
        </h1>

        <div class="mt-8">
          <Message severity="info" v-if="order.status === 'pending'">
            Votre paiement est encore en cours de traitement.
            <br/>Retrouvez votre bon de retrait ici une fois que celui-ci aura été validé.
          </Message>

          <Message severity="error" v-if="order.status === 'canceled'">
            Votre commande a été annulée.
          </Message>

          <Message severity="error" v-if="order.status === 'refunded'">
            Votre commande a été remboursée.
          </Message>

          <table class="size-full" v-if="isPickupSlipAvailable">
            <tbody>
            <tr v-for="(row, index) in referenceTableRows" :class="{ 'bg-slate-200': (index %2 === 0) }">
              <td class="p-2 font-bold text-left">{{ row[0] }} :</td>
              <td class="p-2 text-left whitespace-pre	">{{ row[1] }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-12 flex flex-row gap-4 justify-center print:hidden" v-if="isPickupSlipAvailable">
          <Button @click="printSlip">
            Imprimer
          </Button>

          <!--
          <Button as="a" :href="route('order.pickup-slip.download', { key })" target="_blank">
            Télécharger
          </Button>
          -->
        </div>
      </div>
    </main>
  </div>
</template>
